import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { faqs } from '../data/content';
import { Button } from './ui/Button';
import { useConsult } from '../contexts/ConsultContext';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const reduce = useReducedMotion();
  const {
    openConsult
  } = useConsult();
  return <section id="faq" className="w-full bg-ash-50 py-20 lg:py-28" data-id="element-26" data-mp="2dzoc38q1nep4">
      <div className="mx-auto grid w-full max-w-7xl gap-12 px-5 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20 lg:px-8" data-id="element-27" data-mp="292eidgvmggvh">
        <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-28" data-mp="240yxppxcwcdm">
          <h2 className="font-display text-4xl leading-tight tracking-tight text-ash-900 lg:text-5xl" data-id="element-29" data-mp="1z3owld0luc9y">
            Straight answers
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ash-600" data-id="element-30" data-mp="soo7nr9zyucv">
            Still unsure? A certified provider will answer everything specific to your skin — at no cost.
          </p>
          <Button className="mt-7" onClick={() => openConsult('faq')} data-id="element-31" data-mp="pj94bhman5jy">
            Ask a provider
          </Button>
        </div>

        <dl className="divide-y divide-ash-300 border-y border-ash-300" data-id="element-32" data-mp="uey51oa1ushu">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.q} data-id="element-33" data-mp="kh0akj1ljzgs" data-mpi={index}>
                <dt data-id="element-34" data-mp="6rg8zgjr5892">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 py-6 text-left transition-colors duration-150 ease-smooth hover:text-royal-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-royal-600" data-id="element-35" data-mp="6r6k5wag174y">
                    <span className="text-lg font-semibold tracking-tight text-ash-900" data-id="element-36" data-mp="3jyi3z5u9sva5">{faq.q}</span>
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-ash-300 text-royal-600" data-id="element-37" data-mp="3nz21iaira0wt">
                      {isOpen ? <MinusIcon className="h-4 w-4" data-id="element-38" data-mp="1pqe828wwck2m" /> : <PlusIcon className="h-4 w-4" data-id="element-39" data-mp="1ppclb76iq952" />}
                    </span>
                  </button>
                </dt>
                <AnimatePresence initial={false} data-id="element-40" data-mp="1koyn0gupydk8">
                  {isOpen && <motion.dd initial={reduce ? false : {
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-41" data-mp="1ftjcnyvx6zsk">
                      <p className="max-w-2xl pb-6 text-[15px] leading-relaxed text-ash-600" data-id="element-42" data-mp="1zew5qh9vqb21">{faq.a}</p>
                    </motion.dd>}
                </AnimatePresence>
              </div>;
        })}
        </dl>
      </div>
    </section>;
}